import React from 'react';
import { compose } from 'ramda';

import Price from '@synergycms_core/components/generic/Price';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryEquivalentPrice.js';
import { RichText } from '@synergycms_core/components/generic';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import connect from 'react-redux/es/connect/connect';

const AvailMainSideSummaryEquivalentPrice = class AvailMainSideSummaryEquivalentPrice extends React.Component {
  static displayName = 'AvailMainSideSummaryEquivalentPrice';

  render() {
    const { config, theme } = this.props,
      {
        totalPrice,
        hotelCurrencyCode,
        currentCurrencyCode,
        removeGap,
        altCurrency
      } = config;
    
    const { classes } = theme.styles;

    if((hotelCurrencyCode !== currentCurrencyCode) || altCurrency) {
      return (
        <div className={[classes.contentModule, removeGap ? classes.removeGap : ''].join(' ')}>
          <RichText
            text={'_%importe equivalente a%_'}
            ucFirst={true}
            innerStyle={['roboto11SoftGray300']}
            translate={true}
          />{' '}
          <Price innerStyle={['summaryPriceSmallSoftGray']} amount={totalPrice} forceHotelCurrency={true} altCurrency={altCurrency}/>
        </div>
      );
    }
    return null;
  }
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);

  return {
    currentCurrencyCode: store.getIn(['customer', 'current_currency']) || undefined,
    hotelCurrencyCode: store.getIn(['hotels', hotelId, 'currency', 'code']),
  };
};


export default compose(
  validateAsyncComponent(mapStateToProps),
  connect(
    mapStateToProps,
  ),
  PropertyManager([
    'totalPrice',
    'currentCurrencyCode',
    'hotelCurrencyCode',
    'removeGap',
    'altCurrency'
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryEquivalentPrice);
